import { CasaviDashboardView } from "./casavi-dashboard.view";

export function CasaviDashboardRoutes() {
  return <CasaviDashboardView />;
}
